import React from 'react';
import './Popup.css'; 
import success from '../../../assets/icons/success.svg';
const Popup = ({ onClose }) => {
  return (
    <div className="popup-overlay">
      <div className="popup-box">
        {/* <div className="popup-icon">
          <span className="checkmark">✓</span>
        </div> */}
        <img src={success} />
        <h2 className="feedback-heading">Thanks for reaching out!</h2>
        <p  className="feedback-para">We’ve received your message and will get back to you shortly. Looking forward to connecting with you!</p>
        <button className="close-btn" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default Popup;
